export default __webpack_public_path__ + "static/media/wallet-money.83e22b7b.svg";